import { Pause, Play } from 'lucide-react';

interface Props {
  paused: boolean;
  onToggle: () => void;
  className?: string;
  variant?: 'light' | 'dark';
}

const CarouselPauseButton = ({ paused, onToggle, className = '', variant = 'light' }: Props) => {
  const styles = variant === 'dark'
    ? 'bg-petrol/60 backdrop-blur-sm text-petrol-foreground hover:bg-petrol/80'
    : 'bg-background/90 text-foreground hover:bg-background shadow-md';

  return (
    <button
      type="button"
      onClick={onToggle}
      className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors ${styles} ${className}`}
      aria-label={paused ? 'Reprendre le défilement automatique' : 'Mettre en pause le défilement'}
      aria-pressed={paused}
    >
      {paused ? <Play size={15} strokeWidth={1.5} /> : <Pause size={15} strokeWidth={1.5} />}
    </button>
  );
};

export default CarouselPauseButton;
